<template>
  <div>
    <iframe-container
      iframe-id="template_iframe"
      :show-iframe="!isLoading && templatePreviewContent"
      :show-empty-state="!isLoading && !templatePreviewContent"
      empty-state-description="This template has no preview yet"
      :preview-content="templatePreviewContent"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IframeContainer from './IframeContainer'

export default {
  name: 'CustomContentTemplate',
  components: {
    IframeContainer
  },
  provide () {
    return {
      iframeContent: () => this.templatePreviewContent,
      isLoading: () => this.isLoading
    }
  },
  data () {
    return {
      test: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  computed: {
    ...mapGetters({
      templatePreviewContent: 'getTemplatePreviewContent'
    }),
    isLoading () {
      return this.$store.getters.getLoadingStatusItem('set_template_preview')
    }
  }
}
</script>
